export const getNameRole = (role) => {
    switch (role.toString().toLowerCase()) {
        case 'supplier':
            return 'Поставщик';

        case 'admin':
            return 'Админ';

        case 'client':
            return 'Клиент';

        default:
            return ''
    }
}